import { useState, useCallback, useRef } from "react";

const useProgressLog = () => {
  const [logs, setLogs] = useState([]);
  const logsRef = useRef([]);

  const forceUpdate = useCallback(() => {
    setLogs([...logsRef.current]);
  }, []);

  const log = useCallback(
    (msg) => {
      logsRef.current.push(msg);
      forceUpdate();
    },
    [forceUpdate]
  );

  const reset = useCallback(() => {
    logsRef.current = [];
    setLogs([]);
  }, []);

  return { logs, logsRef, log, reset };
};

export default useProgressLog;
